export default __webpack_public_path__ + "static/media/Group 92.0f31b2ea.svg";